import apiFetch from "./apiFetch";

const getSeries = (params) => apiFetch('/series', params);

export {
  getSeries,
};
